module.exports = __webpack_public_path__ + "img/elaqat.71ecace1.png";